// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:where(.vuetify-styles) .v-system-bar {
  align-items: center;
  display: flex;
  flex: 1 1 auto;
  height: 24px;
  justify-content: flex-end;
  max-width: 100%;
  padding-inline: 8px;
  position: relative;
  text-align: end;
  width: 100%;
}
:where(.vuetify-styles) .v-system-bar .v-icon {
  opacity: var(--v-medium-emphasis-opacity);
}
:where(.vuetify-styles) .v-system-bar {
  box-shadow: 0px 0px 0px 0px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, 0.2)), 0px 0px 0px 0px var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, 0.14)), 0px 0px 0px 0px var(--v-shadow-key-ambient-opacity, rgba(0, 0, 0, 0.12));
}
:where(.vuetify-styles) .v-system-bar--absolute {
  position: absolute;
}
:where(.vuetify-styles) .v-system-bar--fixed {
  position: fixed;
}
:where(.vuetify-styles) .v-system-bar {
  background: rgba(var(--v-theme-surface-light));
  color: rgba(var(--v-theme-on-surface-light), var(--v-high-emphasis-opacity));
}
:where(.vuetify-styles) .v-system-bar {
  font-size: 0.75rem;
  font-weight: 400;
  letter-spacing: 0.0333333333em;
  line-height: 1.667;
  text-transform: none;
}
:where(.vuetify-styles) .v-system-bar--rounded {
  border-radius: 0;
}
:where(.vuetify-styles) .v-system-bar--window {
  height: 32px;
}
:where(.vuetify-styles) .v-system-bar:not(.v-system-bar--absolute) {
  padding-inline-end: calc(var(--v-scrollbar-offset) + 8px);
}`, "",{"version":3,"sources":["webpack://./node_modules/vuetify/lib/components/VSystemBar/VSystemBar.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,aAAa;EACb,cAAc;EACd,YAAY;EACZ,yBAAyB;EACzB,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,WAAW;AACb;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,sOAAsO;AACxO;AACA;EACE,kBAAkB;AACpB;AACA;EACE,eAAe;AACjB;AACA;EACE,8CAA8C;EAC9C,4EAA4E;AAC9E;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,8BAA8B;EAC9B,kBAAkB;EAClB,oBAAoB;AACtB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,YAAY;AACd;AACA;EACE,yDAAyD;AAC3D","sourcesContent":[".v-system-bar {\n  align-items: center;\n  display: flex;\n  flex: 1 1 auto;\n  height: 24px;\n  justify-content: flex-end;\n  max-width: 100%;\n  padding-inline: 8px;\n  position: relative;\n  text-align: end;\n  width: 100%;\n}\n.v-system-bar .v-icon {\n  opacity: var(--v-medium-emphasis-opacity);\n}\n.v-system-bar {\n  box-shadow: 0px 0px 0px 0px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, 0.2)), 0px 0px 0px 0px var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, 0.14)), 0px 0px 0px 0px var(--v-shadow-key-ambient-opacity, rgba(0, 0, 0, 0.12));\n}\n.v-system-bar--absolute {\n  position: absolute;\n}\n.v-system-bar--fixed {\n  position: fixed;\n}\n.v-system-bar {\n  background: rgba(var(--v-theme-surface-light));\n  color: rgba(var(--v-theme-on-surface-light), var(--v-high-emphasis-opacity));\n}\n.v-system-bar {\n  font-size: 0.75rem;\n  font-weight: 400;\n  letter-spacing: 0.0333333333em;\n  line-height: 1.667;\n  text-transform: none;\n}\n.v-system-bar--rounded {\n  border-radius: 0;\n}\n.v-system-bar--window {\n  height: 32px;\n}\n.v-system-bar:not(.v-system-bar--absolute) {\n  padding-inline-end: calc(var(--v-scrollbar-offset) + 8px);\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
